import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/sidebar.css";
import { AuthContext } from "../utility/AuthContext";

export default function Sidebar({ sidebarCollapsed }) {
  const navigate = useNavigate();
  const [masterDropdown, setMasterDropdown] = useState(false);
  const [reportDropdown, setReportDropdown] = useState(false);
  const { user } = useContext(AuthContext);

  return (
    <div
      className="d-flex flex-column bg-white border-end pt-5"
      style={{
        width: sidebarCollapsed ? "0px" : "250px",
        height: "100vh",
        transition: "width 0.3s ease",
        fontSize: "1.1rem",
      }}
    >
      <ul className="nav flex-column mt-3">
        <li
          className="nav-item px-3 mb-2 sidebar-item"
          onClick={() => {
            navigate("/dashboard");
          }}
        >
          <i className="bi bi-briefcase-fill me-2 text-success"></i>
          <span>{!sidebarCollapsed && "Dashboard"}</span>
        </li>
        {user.role === "Head" && (
          <>
            <li
              className="nav-item px-3 mb-2 py-2 rounded d-flex flex-row justify-content-between sidebar-item"
              onClick={() => setMasterDropdown(!masterDropdown)}
            >
              <span>
                <i className="bi bi-briefcase-fill me-2 text-success"></i>
                {!sidebarCollapsed && "Master"}
              </span>
              <i
                className={`bi bi-arrow-${masterDropdown ? "up" : "down"} me-3`}
              ></i>
            </li>

            <ul
              className={`list-unstyled ps-5 text-dark ${
                masterDropdown ? "d-block" : "d-none"
              }`}
            >
              <li
                className="text-secondary sidebar-list-item"
                onClick={() => {
                  navigate("/exam-master");
                }}
              >
                {!sidebarCollapsed && "Exam Master"}
              </li>
              <li
                className="text-secondary sidebar-list-item"
                onClick={() => {
                  navigate("/grade-master");
                }}
              >
                {!sidebarCollapsed && "Grade Master"}
              </li>
              <li
                className="text-secondary sidebar-list-item"
                onClick={() => {
                  navigate("/subject-master");
                }}
              >
                {!sidebarCollapsed && "Subject Master"}
              </li>
            </ul>
          </>
        )}

        {user.role === "Exam" && (
          <>
            <li
              className="nav-item px-3 mb-2 sidebar-item"
              onClick={() => navigate("/marks-entry")}
            >
              <i className="bi bi-briefcase-fill me-2 text-success"></i>
              <span>{!sidebarCollapsed && "Marks Entry"}</span>
            </li>

            <li
              className="nav-item px-3 mb-2 py-2 rounded d-flex flex-row justify-content-between sidebar-item"
              onClick={() => setReportDropdown(!reportDropdown)}
            >
              <span>
                <i className="bi bi-briefcase-fill me-2 text-success"></i>
                {!sidebarCollapsed && "Reports"}
              </span>
              <i
                className={`bi bi-arrow-${reportDropdown ? "up" : "down"} me-3`}
              ></i>
            </li>

            <ul
              className={`list-unstyled ps-5 text-dark ${
                reportDropdown ? "d-block" : "d-none"
              }`}
            >
              <li
                className="text-secondary sidebar-list-item"
                onClick={() => {
                  navigate("/exam-wise-report");
                }}
              >
                {!sidebarCollapsed && "Exam Wise Report"}
              </li>
              <li
                className="text-secondary sidebar-list-item"
                onClick={() => {
                  navigate("/half-yearly-report");
                }}
              >
                {!sidebarCollapsed && "Half Yearly Report"}
              </li>
            </ul>
          </>
        )}
      </ul>
    </div>
  );
}
